import React from "react";

// css
import "./Performance.css";

const PerformanceHeaderCard = (props) => {
  function addTwoMonthsAndFormat(dateStr) {
    // Parse the date (MM/DD/YYYY format)
    let [month, day, year] = dateStr.split("/").map(Number);

    // Create a date object
    let date = new Date(year, month - 1, day);

    // Add 2 months
    date.setMonth(date.getMonth() + 2);

    // Format as "Month YYYY"
    return date.toLocaleString("en-US", { month: "long", year: "numeric" });
  }

  console.log(props.nDate);
  return (
    <section>
      <div className="performance-main-wrapper">
        <div className="main-margin performance-neg-margin">
          <div className="performance-card-grid">
            {props.nAmount ? (
              <div className="performance-card table-shadow-main">
                <h3 className="m-t-0">
                  NAV per share<sup className="small-sup">1</sup>
                </h3>
                <h1>${props.nAmount}</h1>
                <p>
                  Transaction Price for {addTwoMonthsAndFormat(props.nDate)}
                </p>
              </div>
            ) : null}
            {props.ayp ? (
              <div className="performance-card table-shadow-main">
                <h3 className="m-t-0">
                  Annualized Distribution Rate<sup className="small-sup">2</sup>
                </h3>
                <h1>{props.ayp}%</h1>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerformanceHeaderCard;
